import { useCallback, useContext, useRef, useState } from "react";
import MyNameIsStep from "./MyNameIsStep";
import SwipeableViews from "react-swipeable-views";
import LandingStep from "./LandingStep";
// import MyPhoneNumberIsStep from "./MyPhoneNumberIsStep";
// import IWantToConnectMyStep from "./IWantToConnectMyStep";
// import IStudyInStep from "./IStudyInStep";
// import MyOtpIsStep from "./MyOtpIsStep";
import { FormProvider, useForm } from "react-hook-form";
import { Drawer } from "@material-ui/core";
import BoardingFlowContextProvider, {
  BoardingFlowContext,
} from "../../context/auth/BoardingFlowContext";
import MyOtpIsStep from "./MyOtpIsStep";
import MyPhoneNumberIsStep from "./MyPhoneNumberIsStep";
import IWantToConnectMyStep from "./IWantToConnectMyStep";
import IStudyInStep from "./IStudyInStep";
import { useMediaQuery } from "react-responsive";
import CloseIcon from "@material-ui/icons/Close";

export interface BaseStepProps {
  isActive: boolean;
  isOpen: boolean;
  isOpenAndActive: boolean;
  reset: () => void;
}

function OnBoardingFlowView({ isOpen }: { isOpen: boolean }) {
  const [phoneRoute, setPhoneRoute] =
    useContext(BoardingFlowContext).phoneRoute;
  const allowCloseRef = useContext(BoardingFlowContext).allowCloseRef;
  const [activeTab, setActiveTab] = useContext(BoardingFlowContext).activeTab;
  const formMethods = useForm({
    defaultValues: {
      phoneNumber: "+91",
      countryCode: "+91",
      email: null,
      name: null,
    },
  });
  const landingStepRef = useRef(null);
  const myPhoneNumberIsStepRef = useRef(null);
  const myOtpIsStepAt1Ref = useRef(null);
  const myOtpIsStepAt2Ref = useRef(null);
  const iWantToConnectStepRef = useRef(null);
  const iStudyInStepRef = useRef(null);
  const myNameIsStepRef = useRef(null);

  const reset = useCallback(() => {
    allowCloseRef.current = true;
    setActiveTab(0);
    formMethods.reset();
    formMethods.clearErrors();

    landingStepRef.current?.reset();
    myPhoneNumberIsStepRef.current?.reset();
    myOtpIsStepAt1Ref.current?.reset();
    myOtpIsStepAt2Ref.current?.reset();
    iWantToConnectStepRef.current?.reset();
    iStudyInStepRef.current?.reset();
    myNameIsStepRef.current?.reset();
  }, [allowCloseRef, formMethods, setActiveTab]);

  return (
    <FormProvider {...formMethods}>
      <SwipeableViews
        axis={"x"}
        index={activeTab}
        // onChangeIndex={(e) => setActiveTab(e)}
        scrolling={"false"}
        className="swipeable__onboarding"
        containerStyle={{
          transition: "transform 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s",
          background: "#161616",
          width: "700px",
        }}
        style={{ background: "#161616" }}
        slideStyle={{ background: "#161616" }}
        disabled={true}
        ignoreNativeScroll={true}
      >
        <LandingStep
          ref={landingStepRef}
          isOpen
          isActive={activeTab === 0}
          isOpenAndActive={activeTab === 0}
          reset={reset}
        />
        {phoneRoute ? (
          <MyOtpIsStep
            ref={myOtpIsStepAt1Ref}
            isOpen
            isActive
            isOpenAndActive
            reset={reset}
          />
        ) : (
          <MyPhoneNumberIsStep
            isOpen
            isActive
            isOpenAndActive
            reset={reset}
            ref={myPhoneNumberIsStepRef}
          />
        )}
        {phoneRoute ? (
          <IWantToConnectMyStep
            isOpen
            isActive
            isOpenAndActive
            reset={reset}
            ref={iWantToConnectStepRef}
          />
        ) : (
          <MyOtpIsStep
            isOpen
            isActive
            isOpenAndActive
            reset={reset}
            ref={myOtpIsStepAt2Ref}
          />
        )}
        <IStudyInStep ref={iStudyInStepRef} />
        <MyNameIsStep ref={myNameIsStepRef} />
      </SwipeableViews>
    </FormProvider>
  );
}

interface OnBoardingFlowProps {
  openSlider: boolean;
  setOpenSlider: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function OnBoardingFlow(props: OnBoardingFlowProps) {
  const [activeTab, setActiveTab] = useState(0);
  const allowCloseRef = useRef(true);
  const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });

  return (
    <Drawer
      variant="temporary"
      className="onboarding__slider"
      open={props.openSlider}
      // open={true}
      anchor={isSmallScreen ? "bottom" : "right"}
      onClose={(e, reason) => {
        if (allowCloseRef.current) {
          props.setOpenSlider(false);
        }
      }}
      ModalProps={{ keepMounted: true }}
      BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.75)" } }}
    >
      {isSmallScreen && activeTab !== 1 && (
        <CloseIcon
          style={{
            width: "18px",
            height: "18px",
            position: "fixed",
            top: "10px",
            right: "9px",
            zIndex: 2323123123,
            color: "#ffffff75",
          }}
          onClick={() => {
            allowCloseRef.current && props.setOpenSlider(false);
          }}
        />
      )}
      <BoardingFlowContextProvider
        {...props}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        allowCloseRef={allowCloseRef}
      >
        <OnBoardingFlowView isOpen={true} />
      </BoardingFlowContextProvider>
    </Drawer>
  );
}
